// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"sx_a bhm_b bhm_bj","SubscribedPhotoblogs__link":"sx_b bhm_a bhm_r"};